<template>
  <div class='mainContainer'>
    <div class='nav'>
      <div class='navContainer' style='width: 250px'>
        <p>供应商名称：</p>
        <el-input v-model='teamIpt' size='mini' style='width:150px' placeholder='请输入车队名称' />
      </div>
      <div class='navContainer' style='width: 210px'>
        <p>车牌号：</p>
        <el-input v-model='licenseIpt' size='mini' style='width:150px' placeholder='请输入车牌号' />
      </div>
      <div class='navContainer' style='width: 230px'>
        <p>司机姓名：</p>
        <el-input v-model='nameIpt' size='mini' style='width:150px' placeholder='请输入司机姓名' />
      </div>
      <div class='navContainer' style='width: 210px'>
        <p>批次号：</p>
        <el-input v-model='batchIpt' size='mini' style='width:150px' placeholder='请输入批次号' />
      </div>
      <div class='navContainer' style='width: 230px'>
        <p>运单编号：</p>
        <el-input v-model='waybillIpt' size='mini' style='width:150px' placeholder='请输入运单编号' />
      </div>
      <div class='navContainer' style='width: 210px'>
        <p>车架号：</p>
        <el-input v-model='chassisIpt' size='mini' style='width:150px' placeholder='请输入车架号'
                  @paste.native.capture.prevent="(value)=>{ return searchCopyFormat(value,'chassisIpt')}" />
      </div>
      <div class='navContainer' style='width: 400px'>
        <p>扫码时间：</p>
        <el-date-picker v-model='timeIpt[0]' size='mini' style='width:150px'
                        value-format='yyyy-MM-dd' @change='dateChange' type='date'
                        placeholder='开始日期' />
        <span style='display:inline-block;width:15px;text-align:center;font-size:18px'>-</span>
        <el-date-picker v-model='timeIpt[1]' size='mini' style='width:150px'
                        value-format='yyyy-MM-dd' @change='dateChange' type='date'
                        placeholder='结束日期' />
      </div>
      <div class='navBtn'>
        <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
        <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
        <!-- <el-button size="small" style="height:30px" type="primary" @click="addBtn">手动交车</el-button> -->
      </div>
    </div>
    <div class='content'>
      <div class='tableContainer'>
        <div class='tableContainerNav'>
          <span @click='exportClick'>导出数据</span>
        </div>
        <el-table
          v-loading='tableLoad'
          :data='TableDatas'
          style='width: 100%'
          border
          stripe
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label='序号' align='center' width='50px'>
            <div slot-scope='scope'>{{ scope.$index + 1 }}</div>
          </el-table-column>
          <el-table-column prop='supplierName' label='供应商名称' align='center' />
          <el-table-column prop='taskToolNum' label='车牌号' align='center' />
          <el-table-column prop='taskToolName' label='司机姓名' align='center' />
          <!-- <el-table-column prop="driverPhone" label="司机电话" align="center"/> -->
          <el-table-column prop='batchNumber' label='批次号' align='center' />
          <el-table-column prop='waybillNo' label='运单编号' align='center' />
          <el-table-column prop='frameNumber' label='车架号' align='center' />
          <!-- <el-table-column label="交车位置类型" align="center">
            <div slot-scope="scope">{{getDeliveryType(scope.row.deliveryType)}}</div>
          </el-table-column> -->
          <!-- <el-table-column label="交车类型" align="center">
            <div slot-scope="scope">{{getDeliveryAddressType(scope.row.taskPositionType)}}</div>
          </el-table-column> -->
          <el-table-column prop='taskPeople' label='扫码人' align='center' />
          <el-table-column prop='taskDate' label='交车时间' align='center' />
          <el-table-column prop='taskPositionName' label='扫码地址' align='center' />
          <!--          <el-table-column label="操作" width="165" align="center">-->
          <!--            <template slot-scope="scope">-->
          <!--              <div style="display:flex;align-items:center;padding-left: 10px">-->
          <!--                <el-button size="mini" class="searchBtn" type="primary" @click="detailClick(scope.row.id)">详情</el-button>-->
          <!--                <el-button size="mini" type="danger" @click="failureClick(scope.row.id)">交车失败</el-button>-->
          <!--              </div>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
        </el-table>
      </div>
      <div class='paginationContainer'>
        <span>共{{ total }}条</span>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='sizes,prev, pager, next,jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          @prev-click='contractCurrentChange'
          @next-click='contractCurrentChange'
        />
      </div>
    </div>
    <el-dialog title='详情' :visible.sync='detailDialogVisible' width='600px' center top='10vh'>
      <div class='detail'>
        <div class='baseInfo'>
          <div class='baseInfoTitle'>
            <div class='line' />
            <span>基础信息</span>
          </div>
          <div class='baseInfoContent'>
            <div class='baseInfoContentItem'>
              <span class='span1'>车队名称：</span>
              <span>{{ detailData.fleetName }}</span>
            </div>
            <div class='baseInfoContentItem specialItem'>
              <div class='specialOne'>
                <span class='span1'>车牌号：</span>
                <span>{{ detailData.carName }}</span>
              </div>
              <div>
                <span class='span1'>运单编号：</span>
                <span>{{ detailData.billNumber }}</span>
              </div>
            </div>
            <div class='baseInfoContentItem specialItem'>
              <div class='specialOne'>
                <span class='span1'>司机姓名：</span>
                <span>{{ detailData.driverName }}</span>
              </div>
              <div>
                <span class='span1'>司机电话：</span>
                <span>{{ detailData.driverPhone }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class='baseInfo'>
          <div class='baseInfoTitle'>
            <div class='line' />
            <span>车辆信息</span>
          </div>
          <div class='baseInfoContent'>
            <div class='baseInfoContentItem specialItem'>
              <div class='specialOne'>
                <span class='span1'>批次号：</span>
                <span>{{ detailData.batchNumber }}</span>
              </div>
              <div>
                <span class='span1'>车架号：</span>
                <span>{{ detailData.frameNumber }}</span>
              </div>
            </div>
            <div class='baseInfoContentItem specialItem'>
              <div class='specialOne'>
                <span class='span1'>品牌：</span>
                <span>{{ detailData.brand }}</span>
              </div>
              <div>
                <span class='span1'>型号：</span>
                <span>{{ detailData.model }}</span>
              </div>
            </div>
            <div class='baseInfoContentItem specialItem'>
              <div class='specialOne'>
                <span class='span1'>配置：</span>
                <span>{{ detailData.config }}</span>
              </div>
              <div>
                <span class='span1'>颜色：</span>
                <span>{{ detailData.color }}</span>
              </div>
            </div>
            <div class='baseInfoContentItem'>
              <span class='span1'>附件：</span>
              <span>{{ detailData.fileName }}</span>
            </div>
          </div>
        </div>
        <div class='baseInfo'>
          <div class='baseInfoTitle' v-if='this.detailData.deliveryAddressType===3'>
            <div class='line' />
            <span>扫码信息</span>
          </div>
          <div class='baseInfoContent'>
            <div class='baseInfoContentItem' v-if='this.detailData.deliveryAddressType===3'>
              <span class='span1'>扫码人：</span>
              <span>{{ detailData.codeMan }}</span>
            </div>
            <div class='baseInfoContentItem' v-if='this.detailData.deliveryAddressType===3'>
              <span class='span1'>入库时间：</span>
              <span>{{ getTime(detailData.createTime) }}</span>
            </div>
            <div class='baseInfoContentItem' v-if='this.detailData.deliveryAddressType===3'>
              <span class='span1'>入库地址：</span>
              <span>{{ detailData.houseAddress }}</span>
            </div>
            <div class='baseInfoContentItem' v-if='this.detailData.deliveryAddressType===3'>
              <span class='span1'>入库车位：</span>
              <span>{{ detailData.housePark }}</span>
            </div>
            <div class='baseInfoContentItem'>
              <span class='span1'>照片：</span>
              <div class='imgContainer'>
                <el-image
                  v-for='(item,index) in detailData.img'
                  :key='index'
                  style='width: 100px; height: 100px;margin-right:10px; '
                  :src='baseImgUrl + item'
                  :preview-src-list='[baseImgUrl + item]'
                  fit='cover'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title='手动交车' :visible.sync='dialogVisible' width='750px' center
               :close-on-click-modal='false' top='10vh'>
      <div class='company'>
        <el-form :model='teamData' label-width='100px' :rules='rules' ref='ruleForm'>
          <div class='transport'>
            <div-border label='基础信息'>
              <el-form-item label='选择供应商：' prop='entrust' style='margin-top: 10px'>
                <el-select v-model='teamData.entrust' filterable size='mini' style='width:100%'
                           placeholder='请选择供应商' value-key='fleet_id' @change='entrChange'>
                  <el-option v-for='item in entrustOption' :key='item.fleet_id'
                             :label='item.fleet_name' :value='item' />
                </el-select>
              </el-form-item>
              <el-form-item label='选择运输车：' prop='shippers' style='margin-bottom: 0px;'>
                <el-select v-model='teamData.shippers' filterable size='mini' style='width:100%'
                           placeholder='请选择运输车' @change='entrustChange' value-key='id'>
                  <el-option v-for='item in shippersOption' :key='item.truck_id'
                             :label='item.truck_name' :value='item' />
                </el-select>
              </el-form-item>
              <div v-if='teamData.shippers' style='width: calc(100% - 70px);margin-left: 70px'>
                <el-row>
                  <el-col :span='12'>
                    <el-form-item class='form-item' label='司机姓名：'>
                      {{ teamData.name }}
                    </el-form-item>
                  </el-col>
                  <el-col :span='12'>
                    <el-form-item class='form-item' label='任务编号：'>
                      {{ teamData.task_number }}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span='12'>
                    <el-form-item class='form-item' label='交车区域：'>{{ teamData.delivery_place }}
                    </el-form-item>
                  </el-col>
                  <el-col :span='12'>
                    <el-form-item class='form-item' label='装车区域：'>{{ teamData.start_name }}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item class='form-item' label='装车时间：'> {{ teamData.entruck_date }}
                </el-form-item>
                <!-- <el-form-item label="交车区域：">{{teamData.delivery_place}}</el-form-item> -->

              </div>
            </div-border>
            <!-- @selection-change="handleSelectionChange" -->
            <div-border label='选择委托车'>
              <el-table
                :data='teamData.table'
                style='width: 100%;margin-top: 10px;'
                border

              >
                <!-- <el-table-column type="selection" width="30"/> -->
                <el-table-column prop='batch_number' label='批次号' align='center' />
                <el-table-column prop='bill_number' label='运单号' width='150' align='center' />
                <el-table-column prop='frame_number' label='车架号' width='150' align='center' />
                <el-table-column prop='brand' label='品牌' align='center' />
                <el-table-column prop='model' label='型号' align='center' />
                <!-- <el-table-column prop="config" label="配置" align="center"/> -->
                <el-table-column prop='color' label='颜色' align='center' />
                <!-- <el-table-column prop="weight" label="重量" align="center"/> -->
                <!-- <el-table-column prop="lwh" label="长x宽x高" align="center"/> -->
                <el-table-column prop='file_name' label='附件' width='50' align='center' />
              </el-table>
            </div-border>
            <!-- <div-border label="上传图片" is-need="true">
              <div class="imgUp">
                <div class="imgLength"><span>{{teamData.img.length}}/5</span></div>
                <el-upload
                  ref="uploads"
                  list-type="picture-card"
                  :action="uploadUrl"
                  :data="uploadData"
                  accept="image/png, image/jpeg, image/jpeg, image/bmp, image/gif"
                  :before-upload="beforeAvatarUpload"
                  :on-change="uploadChange"
                  :on-remove="handleRemove"
                  :on-progress="progress"
                  :on-success="success"
                  :file-list="teamData.img"
                  :limit="5"
                >
                  <div class="img-box">
                    <i class="el-icon-plus"/>
                    <span class="tips">点击上传照片</span>
                  </div>
                </el-upload>
              </div>
            </div-border> -->
          </div>
        </el-form>
        <div class='btnContainer'>
          <el-button class='searchBtn' :loading='teamDataLoad' @click='saveClick' size='small'>确定
          </el-button>
          <el-button class='resetBtn' @click='dialogClose' size='small'>取消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import divBorder from '@/components/divBorder';
  import {
    deliveryInfoCvDetail,
    deliveryInfoCvFail,
    deliveryInfoCvPageList,
    deliveryInfoCvGetEntrustCar,
    deliveryInfoCvAdd,
    deliveryInfoCvGetWaitingDeliverySupplier,
  } from '@/service/vehiclelog';
  import { formatDateTime, getSessionStore } from '@/config/mUtils';
  import { baseUrl, baseImgUrl } from '@/config/env';

  export default {
    components: {
      divBorder,
    },
    data() {
      let dateItem = new Date(new Date().getTime() - 144 * 60 * 60 * 1000);	//使用当天时间戳减去以前的时间毫秒（小时*分*秒*毫秒）
      let startDay = dateItem.getFullYear() + '-' +
        (dateItem.getMonth() + 1).toString()
          .padStart(2, '0') + '-' +
        dateItem.getDate()
          .toString()
          .padStart(2, '0');
      let endDay = new Date().getFullYear() + '-' +
        (new Date().getMonth() + 1).toString()
          .padStart(2, '0') + '-' +
        new Date().getDate()
          .toString()
          .padStart(2, '0');
      return {
        baseImgUrl: baseImgUrl + '/',
        uploadUrl: '',
        uploadData: {
          fileType: '1',
        },
        imgIsUpload: false,
        licenseIpt: '',
        nameIpt: '',
        batchIpt: '',
        chassisIpt: '',
        waybillIpt: '',
        teamIpt: '',
        timeIpt: [startDay, endDay],
        page: 1,
        size: 10,
        total: 0,
        tableLoad: false,
        TableDatas: [],
        detailDialogVisible: false,
        detailData: {},
        entrustOption: [],
        shippersOption: [],
        dialogVisible: false,
        teamData: {
          img: [],
        },
        teamDataLoad: false,
        rules: {
          entrust: [
            {
              required: true,
              message: '请选择供应商',
              trigger: 'change',
            },
          ],
          shippers: [
            {
              required: true,
              message: '请选择托运车',
              trigger: 'change',
            },
          ],
        },
      };
    },
    computed: {
      getTime() {
        return function(time) {
          return formatDateTime(time, 'yyyy年mm月dd日 hh:ii:ss');
        };
      },
      getDeliveryType() {
        return function(type) {
          switch (type) {
            case 1:
              return '手动交车';
            case 2:
              return '批量导入';
            case 3:
              return '扫码交车';
          }
        };
      },
      getDeliveryAddressType() {
        return function(type) {
          switch (type) {
            case 1:
              return '委托商';
            case 2:
              return '港口';
            case 3:
              return '经销商';
            // case 2:
            //   return '经销商'
            // case 3:
            //   return '仓库'
            // case 4:
            //   return '港口'
          }
        };
      },
    },
    mounted() {
      this.init();
      this.uploadUrl = baseUrl + '/web/attachment/upload';
    },
    methods: {
      async init() {
       // await this._deliveryInfoCvPageList();

      },
      async _deliveryInfoCvPageList() {
        this.tableLoad = true;
        const res = await deliveryInfoCvPageList(
          {
            rows: this.size,
            page: this.page,
            supplierName: this.teamIpt,   // 供应商名称
            taskToolNum: this.licenseIpt,    // 车牌号
            taskToolName: this.nameIpt,    // 司机姓名
            batchNumber: this.batchIpt,    // 批次号
            frameNumber: this.chassisIpt,  // 车架号
            waybillNo: this.waybillIpt,   // 运单号
            startDate: this.timeIpt[0] ? this.timeIpt[0] : '',
            endDate: this.timeIpt[1] ? this.timeIpt[1] : '',
          },
        );
        this.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.TableDatas = res.data.records;
        this.total = res.data.total;
      },
      // 导出数据
      exportClick() {
        if (!this.timeIpt[0] || !this.timeIpt[1] || this.timeIpt[0] == '' || this.timeIpt[1] == '') {
          return this.$message.warning('请选择开始日期和结束日期！');
        }
        // let token = getSessionStore('token');
        // let url = baseUrl + '/platform/transportScanOperation/export';
        // url += '?batchNumber=' + this.batchIpt + '&waybillNo=' + this.waybillIpt;
        // url += '&frameNumber=' + this.chassisIpt + '&taskType=2';
        // url += '&taskToolName=' + this.nameIpt + '&taskToolNum=' + this.licenseIpt;
        // url += '&supplierName=' + this.teamIpt;
        // url += '&startDate=' + (this.timeIpt[0] ? this.timeIpt[0] : '');
        // url += '&endDate=' + (this.timeIpt[1] ? this.timeIpt[1] : '');
        // url += '&access_token=' + token;
        // window.location.href = url;
        // window.exportExcelGetNew('/platform/transportScanOperation/export', {
        //   batchNumber: this.batchIpt,
        //   waybillNo: this.waybillIpt,
        //   frameNumber: this.chassisIpt,
        //   taskType: 2,
        //   taskToolName: this.nameIpt,
        //   taskToolNum: this.licenseIpt,
        //   supplierName: this.teamIpt,
        //   startDate: (this.timeIpt[0] ? this.timeIpt[0] : ''),
        //   endDate: (this.timeIpt[1] ? this.timeIpt[1] : '')
        // })
        window.exportExcelAllFunc({
          type: 'post',
          url: '/transportScanOperation/export',
          obj: {
            batchNumber: this.batchIpt,
            waybillNo: this.waybillIpt,
            frameNumber: this.chassisIpt,
            taskType: 2,
            taskToolName: this.nameIpt,
            taskToolNum: this.licenseIpt,
            supplierName: this.teamIpt,
            startDate: (this.timeIpt[0] ? this.timeIpt[0] : ''),
            endDate: (this.timeIpt[1] ? this.timeIpt[1] : '')
          },
          name: '交车管理表'
        })
      },
      // 结束时间
      dateChange(val) {
        if (this.timeIpt[1] && this.timeIpt[0] && (this.timeIpt[1] <= this.timeIpt[0])) {
          if (val == this.timeIpt[1]) this.timeIpt[1] = '';
          if (val == this.timeIpt[0]) this.timeIpt[0] = '';
          this.$forceUpdate();
          return this.$message.warning('结束日期必须大于开始日期！');
        }
      },
      beforeAvatarUpload(file) {
        const TypeArr = ['image/jpeg', 'image/png', 'image/bmp', 'image/gif', 'image/jpg'];
        const isJPG = TypeArr.includes(file.type);
        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isJPG) this.$message.error('上传图片只能为jpg/png/jpeg/bmp/gif格式');
        if (!isLt10M) this.$message.error('上传图片大小不能超过 10MB');
        return isJPG && isLt10M;
      },
      uploadChange(file, fileList) {
        this.teamData.img = fileList;
        if (Object.keys(file)
          .includes('response')) {
          if (file.response.status !== 0) {
            this.teamData.img.splice(this.teamData.img.indexOf(file), 1);
          }
        }
      },
      handleRemove(file, fileList) {
        this.teamData.img = fileList;
      },
      progress() {
        this.imgIsUpload = true;
      },
      success(res) {
        if (res.status !== 0) this.$message.error('该图片上传失败！');
        this.$message.success(res.message);
        this.imgIsUpload = false;
      },
      contractSizeChange(sizes) {
        this.size = sizes;
        this._deliveryInfoCvPageList();
      },
      contractCurrentChange(page) {
        this.page = page;
        this._deliveryInfoCvPageList();
      },
      async detailClick(id) {
        this.detailDialogVisible = true;
        const res = await deliveryInfoCvDetail(id);
        if (res.status !== 0) return this.$message.error(res.message);
        this.detailData = {
          ...res.data,
          img: res.data.imgUrl ? res.data.imgUrl.split(',') : [],
        };
      },
      handleSelectionChange(val) {
        this.teamData.selection = val;
      },
      saveClick() {
        this.$refs.ruleForm.validate(async valid => {
          if (valid) {
            // if(this.teamData.selection.length===0){
            //   return this.$message.warning('请至少选择一个委托车！')
            // }
            // let str ='';
            // this.teamData.img.forEach(item=>{
            //   if(!item.response) str+=item.url.split(baseImgUrl+'/')[1]+','
            //   else str += item.response.data.attachmentGroup + '/' + item.response.data.attachmentPath + ','
            // })
            // str = str[str.length-1]===','?str.slice(0,str.length-1):str;
            this.teamDataLoad = true;
            let { fleet_id } = this.teamData.entrust;
            const obj = {
              // img_url:str,
              supplierId: this.teamData.entrust.fleet_id,
              taskToolId: this.teamData.shippers.truck_id,
              // carId:this.teamData.shippers.id,
              // carName:this.teamData.shippers.license,
              // driverId:this.teamData.shippers.driverId,
              // driverName:this.teamData.name,
              // driverPhone:this.teamData.tell,
              // startAddress:this.teamData.start,
              // endAddress:this.teamData.end,
              // startId:this.teamData.startId,
              // endId:this.teamData.deliveryId,
              // deliveryAddressType:this.teamData.deliveryType,
              // carCvList:this.teamData.selection.map(item=>{
              //   return {
              //     id:item.id,
              //     batchNumber:item.batch_number,
              //     billNumber:item.bill_number,
              //     frameNumber:item.frame_number,
              //   }
              // })
            };
            const res = await deliveryInfoCvAdd(obj);
            this.teamDataLoad = false;
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.dialogVisible = false;
            await this._deliveryInfoCvPageList();
          } else {
            return false;
          }
        });
      },
      dialogClose() {
        this.dialogVisible = false;
        this.$refs.ruleForm.resetFields();
      },
      failureClick(id) {
        this.$confirm('确定交车失败吗？确认后，该委托车将回到运输中！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await deliveryInfoCvFail(id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._deliveryInfoCvPageList();
          })
          .catch(() => {
          });
      },
      searchBtn() {
        this.page = 1;
        this._deliveryInfoCvPageList();
      },
      resetBtn() {
        this.licenseIpt = '';
        this.nameIpt = '';
        this.batchIpt = '';
        this.chassisIpt = '';
        this.waybillIpt = '';
        this.teamIpt = '';
        this.timeIpt = ['', ''];
      },
      async addBtn() {
        this.dialogVisible = true;
        this.teamData = {
          entrust: '',
          shippers: '',
          table: [],
          selection: [],
          img: [],
        };
        const res = await deliveryInfoCvGetWaitingDeliverySupplier();
        if (res.status !== 0) {
          this.$message.error(res.message);
        } else {
          this.entrustOption = res.data;
        }
      },
      async entrChange(value) {
        this.shippersOption = value.driverList;

      },
      async entrustChange(value) {
        let {
          driver_name,
          entruck_date,
          task_number,
          start_name,
          delivery_name,
        } = value;
        this.teamData = {
          ...this.teamData,
          name: driver_name ? driver_name : '',
          start_name: start_name ? start_name : '',
          task_number: task_number ? task_number : '',
          entruck_date: entruck_date ? entruck_date : '',
          delivery_place: delivery_name ? delivery_name : '',
        };
        const res = await deliveryInfoCvGetEntrustCar({
          carId: value.truck_id,
          basicId: value.basic_id,
        });
        if (res.status !== 0) return this.$message.error(res.message);
        this.teamData.table = res.data;
      },
      searchCopyFormat(value, flag) {
        let splitArr = value.clipboardData.getData('Text')
          .replace(/\s/g, ',')
          .split(',');
        splitArr = splitArr.filter(item => item);
        splitArr = splitArr[splitArr.length - 1] === '' ? splitArr.slice(0, splitArr.length - 1) : splitArr;
        switch (flag) {
          case 'chassisIpt':
            this.chassisIpt = splitArr.length > 1 ? splitArr.join(',') : splitArr[0];
            break;
        }
      },
    },
  };
</script>

<style lang='scss' scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 25px;
    background-color: #fff;

    .img-box {
      position: relative;
      width: 150px;
      height: 100px;

      img {
        width: 150px;
        height: 100px;
      }

      .tips {
        position: absolute;
        display: none;
      }

      &:hover .tips {
        display: block;
        position: absolute;
        //bottom:0;
        top: 0;
        left: 0;
        color: #FFF;
        width: 146px;
        z-index: 10;
        height: 148px;
        background: #000;
        opacity: 0.6;
      }
    }

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &Container {
        width: 200px;
        display: flex;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 5px;

        p {
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .tableContainerNav {
        font-size: 16px;
        padding-bottom: 3px;
      }

      .tableContainer {
        margin-top: 10px;
        margin-bottom: 25px;
        width: 100%;

        &Nav {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: flex-end;

          span {
            color: rgba(51, 136, 255, 1);
            text-decoration: underline;
            margin-right: 10px;

            &:hover {
              cursor: pointer;
            }
          }
        }

        ::v-deep {
          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    .detail {
      width: 100%;
      padding: 10px 0 20px 20px;
      max-height: 80vh;
      overflow: auto;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;

          &Item {
            margin-bottom: 20px;

            .imgContainer {
              display: flex;
              align-items: center;
            }

            .addressItem {
              font-size: 12px;
              color: rgba(153, 153, 153, 1);
              margin-bottom: 10px;
              margin-left: 70px;
            }

            .span1 {
              font-weight: 700;
            }

            span {
              font-size: 14px;
            }

            .specialOne {
              width: 50%;
            }
          }

          .specialItem {
            display: flex;
          }
        }
      }
    }

    .company {
      width: 100%;
      padding: 20px 10px 10px 10px;
      max-height: 80vh;
      overflow: auto;

      .imgUp {
        display: flex;
        flex-direction: column;
        margin: 10px 0;

        .imgLength {
          display: flex;
          align-items: center;
          width: 100%;

          span {
            margin-left: auto;
            color: rgb(183, 183, 183);
            font-size: 16px;
          }
        }
      }

      .transport {
        width: 100%;
        position: relative;
        padding: 20px 10px;
        margin-bottom: 20px;

        ::v-deep {
          .el-checkbox {
            margin-left: 8px;
          }
        }

        &Title {
          margin-bottom: 0;
          position: absolute;
          top: -21px;
          z-index: 999;
          background-color: #fff;
          left: 20px;
          padding-right: 10px;
          color: rgb(51, 84, 131);
          font-size: 15px;
          font-weight: 700;

          ::v-deep {
            .el-form-item__label {
              color: rgb(51, 84, 131);
              font-size: 15px;
            }
          }
        }
      }

      .productTable {
        margin-top: 15px;

        &Nav {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 10px;

          &Left {
            display: flex;
            align-items: center;

            ::v-deep {
              .el-input--mini .el-input__inner {
                height: 22px;
              }

              .el-input__icon {
                height: 120%;
              }
            }

            span {
              color: #606266;
              font-weight: 700
            }
          }

          &Right {
            text-decoration: underline;
            color: rgb(51, 136, 255);
          }
        }

        ::v-deep {
          .el-checkbox {
            margin-left: 8px;
          }

          .el-input--mini .el-input__inner {
            width: 100%;
          }

          .cell {
            font-size: 10px;
            padding: 0;
          }

          .el-table td, .el-table th {
            padding: 0;
          }
        }

        .tableAddBtnContainer {
          border: 1px solid #EBEEF5;;
          border-top-style: none;
          width: 100%;
          height: 35px;
          display: flex;
          align-items: center;
          padding-left: 15px;

          .AddContainer {
            display: flex;
            align-items: center;

            &:hover {
              cursor: pointer;
            }
          }

          img {
            object-fit: cover;
            margin-right: 5px;
          }

          p {
            font-size: 13px;
            color: #F59A23;
            font-family: 'Arial Normal', 'Arial', sans-serif;
          }
        }
      }

      .update {
        font-size: 14px;
        color: rgba(51, 136, 255, 1);
        text-decoration: underline;
      }

      ::v-deep {
        .el-form-item__label {
          font-weight: 700;
        }

        .el-form-item__label {
          padding: 0;
        }

        .el-form-item {
          margin-bottom: 12px;
        }

        .el-form-item__content {
          position: relative;
        }

        .el-checkbox {
          margin-left: 0;
        }

        .cell {
          font-size: 10px;
          padding: 0;
        }

        .el-table td, .el-table th {
          padding: 0;
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 20px 0 5px 0;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {
      .el-table th > .cell {
        font-weight: 700 !important;
      }
    }
  }


  ::v-deep {
    .el-form-item.form-item {
      margin-bottom: 0px !important;
    }
  }

  ::v-deep {
    .el-table .ui-warning-row {
      background: #DDD !important;
    }

    .el-table .ui-warning-row .cell {
      color: red;
    }

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
    }
  }
</style>
